import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { SavedAddress } from '@/types/store'

export const defaultCheckoutAddress: SavedAddress = {
  id: 'primary',
  label: 'Shipping',
  line1: '',
  landmark: '',
  city: '',
  state: '',
  postalCode: '',
  country: 'India',
}

interface CheckoutFormState {
  fullName: string
  phone: string
  email: string
  address: SavedAddress
  setFullName: (fullName: string) => void
  setPhone: (phone: string) => void
  setEmail: (email: string) => void
  setAddress: (address: SavedAddress) => void
  updateAddressField: (
    field: keyof Pick<
      SavedAddress,
      'line1' | 'landmark' | 'city' | 'state' | 'postalCode' | 'country'
    >,
    value: string
  ) => void
}

export const useCheckoutFormStore = create<CheckoutFormState>()(
  persist(
    (set) => ({
      fullName: '',
      phone: '',
      email: '',
      address: defaultCheckoutAddress,

      setFullName: (fullName) => set({ fullName }),
      setPhone: (phone) => set({ phone }),
      setEmail: (email) => set({ email }),
      setAddress: (address) =>
        set({
          address: { ...defaultCheckoutAddress, ...address },
        }),
      updateAddressField: (field, value) =>
        set((state) => ({
          address: { ...state.address, [field]: value },
        })),
    }),
    {
      name: 'bazm-checkout-form',
      merge: (persisted, current) => {
        const saved = persisted as Partial<CheckoutFormState> | undefined
        if (!saved) return current
        const rawAddr = (saved.address ?? {}) as Partial<SavedAddress> & {
          line2?: string
        }
        return {
          ...current,
          ...saved,
          address: {
            ...defaultCheckoutAddress,
            ...rawAddr,
            landmark: rawAddr.landmark ?? rawAddr.line2 ?? '',
          },
        }
      },
    }
  )
)
